// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store'
import './assets/css/global.css'
import 'gsap'

import LogRocket from 'logrocket'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})

LogRocket.init('qzdbef/mount-sinai')
LogRocket.identify(router.currentRoute.query.device, {
  name: router.currentRoute.query.device
})



// WEBPACK FOOTER //
// ./src/main.js